import React, { useState } from 'react';
import SourceViewer from './SourceViewer';

interface Source {
  id: string;
  title: string;
  page: number;
  content: string;
  type: 'pdf' | 'doc' | 'text';
  url?: string;
}

interface SourceCitationsProps {
  sources: Source[];
}

const SourceCitations: React.FC<SourceCitationsProps> = ({ sources }) => {
  const [selectedSource, setSelectedSource] = useState<Source | null>(null);
  const [isViewerOpen, setIsViewerOpen] = useState(false);

  // Add debugging for sources
  console.log('SourceCitations: Received sources:', sources);

  if (!sources || sources.length === 0) return null;

  const handleOpenSource = (source: Source) => {
    console.log('Opening source:', source);
    setSelectedSource(source);
    setIsViewerOpen(true);
  };

  const handleCloseViewer = () => {
    setIsViewerOpen(false);
  };

  return (
    <div className="mt-4">
      <p className="text-sm text-gray-400 mb-2">Sources:</p>
      <div className="flex flex-wrap gap-2">
        {sources.map((source) => (
          <button
            key={source.id}
            onClick={() => handleOpenSource(source)}
            className="inline-flex items-center gap-1.5 bg-gray-700 hover:bg-gray-600 text-sm rounded-md px-2.5 py-1.5 transition-colors"
          >
            {source.type === 'pdf' ? (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 text-accent">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
              </svg>
            ) : source.type === 'doc' ? (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 text-accent">
                <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 12.75V12A2.25 2.25 0 014.5 9.75h15A2.25 2.25 0 0121.75 12v.75m-8.69-6.44l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z" />
              </svg>
            ) : (
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-4 text-accent">
                <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
              </svg>
            )}
            <span className="text-gray-200 truncate max-w-[150px]">{source.title}</span>
            <span className="text-gray-400 text-xs">p.{source.page}</span>
          </button>
        ))}
      </div>

      {selectedSource && (
        <SourceViewer
          source={selectedSource}
          isOpen={isViewerOpen}
          onClose={handleCloseViewer}
        />
      )}
    </div>
  );
};

export default SourceCitations;
